import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ph-loader',
  templateUrl: './ph-loader.component.html',
  styleUrls: ['./ph-loader.component.scss'],
})
export class PhLoaderComponent {
  @Input() show: boolean = false;
  @Input() fullscreen: boolean = false;
  @Input() static: boolean = false;
  @Input() floating: boolean = false;

  constructor() {}
}
